import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "@mui/material";
import { styled as style } from "@mui/material/styles";
import { useMutation } from "react-query";
import { useNavigate } from "react-router-dom";
import { Modal, Button as RsuiteBtn } from "rsuite";
import Logger from "../../libraries/Logger";
import apiClient from "../../libraries/ApiClient";

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px;
  position: sticky;
  top: 0px;
  .title {
    font-size: 20px;
    color: #252525;
    margin-bottom: 0.5rem;
  }
  .btn {
    display: flex;
    justify-content: space-between;
  }
  @media (max-width: 1200px) {
    top: 50px;
    background-color: #fff;
    z-index: 8;
  }
`;

const CssCancelButton = style(Button)({
  fontSize: 12,
  borderColor: "#057AFF",
  backgroundColor: "#fff",
  padding: "3px 0px",
  "&:hover": {
    borderColor: "#1570EF",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
});

const CssSaveButton = style(Button)({
  fontSize: 12,
  backgroundColor: "#057AFF",
  padding: "4px 0px",
  boxShadow: "none",
  borderColor: "#057AFF",

  "&:hover": {
    backgroundColor: "#1570EF",
    cursor: "pointer",
    boxShadow: "none",
    borderColor: "#057AFF",
  },
});

function HospitalAddTitle({ Mode, rowId, sendHospitalData }) {
  const navigate = useNavigate();
  const [token, setToken] = useState("");
  const [AccountId, setAccountId] = useState("");
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    setToken(JSON.parse(localStorage.getItem("auth"))?.Token);
    if (rowId !== "") {
      setAccountId(JSON.parse(localStorage.getItem("auth"))?.AccountRowId);
    }
  });

  const sendFormData = async ({ sendHospitalData }) => {
    const data = {
      Data: sendHospitalData,
    };

    const result = await apiClient.postAes("api/Organization/Add/Security", data);
    if (result?.status === 401) {
      alert("您的授權已失效，請重新登入");
      navigate("/Login");
    }
    if (+result?.data?.Code !== 0 || result?.status !== 200) {
      alert("機構新增失敗");
    }

    return result;
  };

  const { data, mutate, isSuccess, isLoading } = useMutation(sendFormData);

  const { data: FormResData } = data || {};

  useEffect(() => {
    const code = +FormResData?.Code;
    if (isSuccess && code === 0) {
      alert("新增成功");
      navigate("/HospitalManageList");
    }
    if (code === 1 || code === 2) {
      alert(FormResData?.Message);
    }
  }, [FormResData]);

  return (
    <Container>
      <div className="title">新增合作機構</div>
      <div className="btn">
        <div>
          <CssCancelButton
            size="small"
            variant="outlined"
            style={{ minWidth: "70px" }}
            onClick={handleOpen}
          >
            取消
          </CssCancelButton>
        </div>
        <div style={{ marginLeft: "16px" }}>
          <CssSaveButton
            size="small"
            variant="contained"
            style={{ minWidth: "70px" }}
            onClick={() => {
              mutate({ sendHospitalData });
            }}
          >
            存檔
          </CssSaveButton>
        </div>
      </div>
      <Modal open={open} onClose={handleClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>提示資訊</Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "18px" }}>若有資料未儲存</div>
          <div style={{ fontSize: "14px" }}>「確認」取消將不保留您的資料</div>
        </Modal.Body>
        <Modal.Footer>
          <RsuiteBtn
            onClick={() => {
              navigate("/HospitalManageList");
            }}
            appearance="primary"
          >
            確認
          </RsuiteBtn>
          <RsuiteBtn onClick={handleClose}>取消返回</RsuiteBtn>
        </Modal.Footer>
      </Modal>
      <Modal backdrop="static">
        <Modal.Body
          style={{
            height: "100px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-around",
          }}
        >
          <div style={{ fontSize: "14px" }}>新增中</div>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </Container>
  );
}

export default HospitalAddTitle;
